import 'jquery.fancytree/dist/skin-lion/ui.fancytree.less';
import { Globals } from './globals';
const ɵ0 = (Globals.isProd ? Globals.API_HOST : window['_servlet_name'] || '') + '/app';
export class AppModule {
    constructor() {
    }
}
export { ɵ0 };
